<script setup>
import { computed } from 'vue';

const props = defineProps({
    page: {
        type: String,
        required: true,
    },
    loaded: {
        type: Boolean,
        default: false,
    }
});

const formSkeleton = "heading, paragraph, paragraph, paragraph, paragraph, paragraph, actions";

const loaderTypes = {
    edit: formSkeleton,
    view: formSkeleton,
    list: "table-tbody,table-row",
};

const currentSkeleton = computed(() => loaderTypes[props.page]);
</script>
<template>
    <div>
        <v-skeleton-loader
            v-if="!loaded"
            :type="currentSkeleton"
            class="pa-4"
        ></v-skeleton-loader>
        <slot v-else></slot>
    </div>
</template>

